<template>
  <v-card class="fill-height"
          v-bind="$attrs">
    <v-card-text>
      <div>
        {{ title }}
      </div>
      <div class="d-flex align-end">
        <h2 class="mb-0 font-weight-bold text-h3">
          {{ calculatedRate }}<small>%</small>
        </h2>
        <v-spacer></v-spacer>
        <h2 class="mb-0 font-weight-bold text-h4">
          {{ count | number }}
        </h2>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    rate: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  computed: {
    calculatedRate() {
      const calculatedRate = this.rate * 100;
      if (calculatedRate === 0) {
        return 0;
      } else if (calculatedRate >= 100) {
        return 100;
      }
      return Number(calculatedRate).toFixed(1);
    }
  }
}
</script>
